





import Vue from 'vue'

import requireLogin from '~/middleware/requireLogin'

export default Vue.extend({
  middleware: [requireLogin],
})
